import type { KYDFilters } from "../interfaces/KYDCampaign";
import type { MarketingCustomAudience } from "../interfaces/KYDMarketing";

/** Base filters for `querySegmentCount` when materializing KYD marketing audiences. */
export const KYD_SEGMENT_COUNT_BASE: KYDFilters = {
  gender: "any",
  age: { operator: ">=", value: 0 },
  average_items_per_order: { operator: ">=", value: 0 },
  average_order_value: { operator: ">=", value: 0 },
  order_count: { operator: ">=", value: 0 },
  total_attendance: { operator: ">=", value: 0 },
  venues: [],
  events: [],
  custom_tags: [],
};

/**
 * Normalizes genre/artist/event ids stored on marketing audiences.
 * Accepts plain strings (strategy seeds, API wire) or `{ key, value }` (dashboard MultiSelect).
 */
export function normalizeKydAudienceFilterStrings(
  items: readonly unknown[] | undefined
): string[] {
  if (!items?.length) return [];
  return items
    .map((item) => {
      if (item == null) return "";
      if (typeof item === "string") return item;
      if (typeof item === "object") {
        const o = item as {
          key?: string | null;
          value?: string | null;
          label?: string | null;
        };
        // Prefer stable ids (value/key). label is display-only and must not drive Athena IN lists.
        return o.value ?? o.key ?? "";
      }
      return String(item);
    })
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
}

export function buildKydSegmentFiltersFromMarketingAudienceMetadata(
  metadata: MarketingCustomAudience["metadata"] | undefined
): KYDFilters {
  return {
    ...KYD_SEGMENT_COUNT_BASE,
    genres: normalizeKydAudienceFilterStrings(metadata?.genres),
    performers: normalizeKydAudienceFilterStrings(metadata?.artists),
    events: normalizeKydAudienceFilterStrings(metadata?.events),
  };
}
